import React, { useState, useEffect } from 'react';

const AddAgReport = ({ onClose, workspaceId, onAddReport, initialData = null }) => {
  const [formData, setFormData] = useState({
    report_type: '',
    report_link: '',
    box_folder_id: '',
    report_name: '',
    report_content_type: '',
    status: '',
    meta_table: '',
    meta_dbType: '',
    meta_database: '',
  });
  const [token, setToken] = useState(null);

  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    if (savedToken) {
      setToken(savedToken);
    }
    if (initialData) {
      setFormData({
        report_type: initialData.report_type,
        report_link: initialData.report_link,
        box_folder_id: initialData.box_folder_id,
        report_name: initialData.report_name,
        report_content_type: initialData.report_content_type,
        status: initialData.status,
        meta_table: initialData.meta?.table || '',
        meta_dbType: initialData.meta?.dbType || '',
        meta_database: initialData.meta?.database || '',
      });
    } else {
      // Clear form data if adding a new report
      setFormData({
        report_type: '',
        report_link: '',
        box_folder_id: '',
        report_name: '',
        report_content_type: '',
        status: '',
        meta_table: '',
        meta_dbType: '',
        meta_database: '',
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
      workspace_id: workspaceId,
      meta: {
        table: formData.meta_table,
        dbType: formData.meta_dbType,
        database: formData.meta_database,
      },
    };

    const url = initialData
      ? `https://stage-apiplatform.finkraft.ai/api/meta/edit-report/${initialData.id}`
      : 'https://stage-apiplatform.finkraft.ai/api/meta/add-reports';

    const method = initialData ? 'PUT' : 'POST';

    await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload),
    });

    onAddReport();
    onClose();
  };

  return (
    <div className="add-ag-report-modal-container">
      <div className="add-ag-report-modal-content">
        <h2>{initialData ? 'Edit Report' : 'Add New Report'}</h2>
        <form onSubmit={handleSubmit} className="add-ag-report-form">
          <div className="form-group">
            <label>Report Type</label>
            <input type="text" name="report_type" value={formData.report_type} onChange={handleChange}  />
          </div>
          <div className="form-group">
            <label>Report Link</label>
            <input type="text" name="report_link" value={formData.report_link} onChange={handleChange}  />
          </div>
          <div className="form-group">
            <label>Box Folder ID</label>
            <input type="text" name="box_folder_id" value={formData.box_folder_id} onChange={handleChange}  />
          </div>
          <div className="form-group">
            <label>Report Name</label>
            <input type="text" name="report_name" value={formData.report_name} onChange={handleChange}  />
          </div>
          <div className="form-group">
            <label>Content Type</label>
            <input type="text" name="report_content_type" value={formData.report_content_type} onChange={handleChange}  />
          </div>
          <div className="form-group">
            <label>Status</label>
            <input type="text" name="status" value={formData.status} onChange={handleChange}  />
          </div>
          <div className="form-group">
            <label>Meta Table</label>
            <input type="text" name="meta_table" value={formData.meta_table} onChange={handleChange}  />
          </div>
          <div className="form-group">
            <label>Meta DB Type</label>
            <input type="text" name="meta_dbType" value={formData.meta_dbType} onChange={handleChange}  />
          </div>
          <div className="form-group">
            <label>Meta Database</label>
            <input type="text" name="meta_database" value={formData.meta_database} onChange={handleChange}  />
          </div>
          <button type="submit">{initialData ? 'Update' : 'Add'}</button>
          <button type="button" onClick={onClose}>Cancel</button>
        </form>
      </div>
    </div>
  );
};

export default AddAgReport;
